import { Injectable } from '@angular/core';
import { ApiHttpService } from './api-http.service';
import { Observable } from 'rxjs';
import { StringifyOptions } from 'querystring';

@Injectable()
export class SprayBoothStudyService {
  constructor(private apiHttp: ApiHttpService) { }

  public getAllActives = (): Observable<ActiveModel> => {
    return this.apiHttp.get<ActiveModel>(`actives`);
  }

  public getAllTimepoints = (): Observable<ApplicationTimepoint> => {
    return this.apiHttp.get<ApplicationTimepoint>(`applicationTimepoints`);
  }

  public getAllVolumes = (): Observable<ApplicationVolume> => {
    return this.apiHttp.get<ApplicationVolume>(`applicationVolumes`);
  }

  public getAllAdjuvantUnits = (): Observable<AdjuvantUnit> => {
    return this.apiHttp.get<AdjuvantUnit>(`adjuvantunits`);
  }

  public getAllAdjuvants = (): Observable<AdjuvantModel> => {
    return this.apiHttp.get<AdjuvantModel>(`adjuvants`);
  }

  public getAllRateUnits = (): Observable<RateUnit> => {
    return this.apiHttp.get<RateUnit>(`rateUnits`);
  }
}

export interface SprayBoothStudy {
  sprayStudy: boolean;
  applicationVolume: ApplicationVolume[];
  applicationTimepoint: ApplicationTimepoint[];
  active: ActiveModel[];
  adjuvant: AdjuvantModel[];
}

export interface ApplicationVolume {
  id: number;
  order: number;
  volume: string;
  isActive: boolean;
}

export interface ActiveModel {
  id: number;
  order: number;
  concentrationValue: string;
  factsid: string;
  herbicideTradeName: string;
  activeIngredient: string;
  concentrationUnit: string;
  isActive: boolean;
}

export interface Active {
  id: number;
  herbicideTradeName: string[];
  activeIngredient: string;
  concentrationValue: string;
  concentrationUnit: string;
  rateValue: number[];
  rateUnit: RateUnit[];
  relativeFieldRate: number[];
}

export interface ApplicationTimepoint {
  id: number;
  order: number;
  timepoint: string;
  isActive: boolean;
}

export interface AdjuvantUnit {
  id: number;
  order: number;
  unit: string;
  isActive: boolean;
  adjuvantUnitId: number;
}
export interface AdjuvantModel {
  id: number;
  order: number;
  name: string;
  isActive: boolean;
  adjuvantUnitId: number;
}
export interface Adjuvant {
  adjuvantName: string[];
  adjuvantValue: number[];
  adjuvantUnit: string[];
}

export interface RateUnit {
  id: number;
  order: number;
  unit: string;
  isActive: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/spray-booth-study.service.ts